const supportLanguage = require('./supportLanguage')

const langConfig = {
  ...supportLanguage
}

module.exports = langConfig
